<template>
  <div class="salesDetail">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">损溢明细表</div>
        <div class="select-container">
          <div class="select-container-box tab">
            <el-select
              v-model="memoryValue"
              size="small"
              placeholder="请选择"
              @change="changeBatDateList"
            >
              <el-option
                v-for="item in batDateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box" v-if="memoryValue == 'date'">
            <el-date-picker
              size="small"
              v-model="start"
              :clearable="false"
              type="date"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
              @change="changeTime(0)"
              :picker-options="pickerTimeOptions"
            >
            </el-date-picker>
            <span class="space-text">至</span>
            <el-date-picker
              size="small"
              v-model="end"
              type="date"
              :clearable="false"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="changeTime(1)"
              :picker-options="pickerOptionsEnd"
            >
            </el-date-picker>
          </div>
          <div class="select-container-box" v-if="memoryValue == 'Batch'">
            <el-select
              v-model="batchNo"
              filterable
              placeholder="请选择"
              size="small"
              @change="batchChange"
            >
              <el-input
                class="select-input"
                v-model="batchValue"
                placeholder="请输入内容"
                v-if="batchList.length > 7"
              ></el-input>
              <el-option
                v-for="(item, index) in batchListFilter(batchValue, batchList)"
                :key="index"
                :label="item.batchNo"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>类型&nbsp;&nbsp;</span>
            <el-select
              v-model="isLoss"
              filterable
              size="small"
              @change="isLossChange"
            >
              <el-option
                v-for="(item, index) in isLossList"
                :key="index"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </div>
          <el-popover
            class="pop-condition"
            placement="bottom"
            width="580"
            trigger="click"
            v-model="visible"
          >
            <div class="condition">
              <section class="mask">
                <div class="select-container-box">
                  <span>仓&nbsp;&nbsp;&nbsp;库：</span>
                  <el-select
                    placeholder="请选择"
                    size="small"
                    @click.native="hide"
                    v-model="warehouseId"
                    @change="changeWare"
                  >
                    <el-input
                      class="select-input"
                      v-model="wareHouseValue"
                      placeholder="请输入内容"
                      v-if="warehouseList.length > 7"
                    ></el-input>
                    <el-option
                      v-for="(item, index) in listFilter(
                        wareHouseValue,
                        warehouseList
                      )"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="select-container-box">
                  <span>产&nbsp;&nbsp;&nbsp;品：</span>
                  <el-select
                    v-model="productId"
                    size="small"
                    filterable
                    placeholder="请选择"
                    style="margin-left: 15px"
                    @change="changeProduct"
                  >
                    <el-input
                      class="select-input"
                      v-model="productValue"
                      placeholder="请输入内容"
                      v-if="productList.length > 7"
                    ></el-input>
                    <el-option
                      v-for="item in listFilter(productValue, productList)"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="select-container-box">
                  <span>批次号：</span>
                  <el-input
                    type="text"
                    clearable
                    v-model="batchLike"
                    placeholder="请输入批次号"
                  ></el-input>
                </div>
              </section>
              <div class="comfirm">
                <span class="cancel" @click="visible = false">取消</span>
                <span class="query" @click="search()">查询</span>
              </div>
            </div>
            <div class="more" slot="reference">更多条件</div>
          </el-popover>
          <div class="select-container-box">
            <el-button
              size="small"
              type="info"
              plain
              @click="search()"
              class="query"
              >查询</el-button
            >
            <el-button
              size="small"
              style="background: #0fce82; border: none"
              type="info"
              plain
              @click="exportData"
              class="add"
              >导出</el-button
            >
          </div>
        </div>
      </div>
      <div class="table-container">
        <el-table
          border
          :summary-method="getSummaries"
          show-summary
          :data="utils.tableFill(purchaseList)"
          style="width: 100%"
          size="medium"
          v-loading="loading"
          :default-sort="{ prop: 'date', order: 'descending' }"
          :row-class-name="tableRowClassName"
        >
          <i slot="empty" style="font-style: normal" v-if="noData"
            >该时间段暂无数据</i
          >
          <i
            slot="empty"
            style="
              font-style: normal;
              position: relative;
              top: 18px;
              color: #666;
              z-index: 9999999;
            "
            v-if="loading"
            >数据拼命加载中.......</i
          >
          <el-table-column
            prop="type"
            label="类型"
            width="100"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.type == false ? "损耗单" : "溢余单" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="dataDate"
            label="日期"
            show-overflow-tooltip
            :formatter="formatter"
            align="center"
            width="120"
          >
          </el-table-column>

          <el-table-column
            prop="warehouse"
            label="仓库"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="batch"
            label="批次"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="productName"
            label="产品名称"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="state"
            label="状态"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="species"
            label="规格"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="detailQuantity"
            label="数量"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="detailWeight"
            label="总重量"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.detailWeight.toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="detailPrice"
            label="均价"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="amount"
            label="总金额"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.amount.toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="cause"
            label="原因"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
        </el-table>
        <page-change :pageInfo="pageInfo"></page-change>
      </div>
    </div>
  </div>
</template>

<script>
import PageChange from "../common/PageChange";
import { mapState, mapActions } from "vuex";
import { modules } from "../../store";
import { storage } from "../../service/storage";
import checkPermission from "../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
export default {
  name: "gainLossDeatil",
  mixins: [mixins],
  components: {
    PageChange,
  },
  data() {
    return {
      noData: false,
      loading: true,
      visible: false,
      batchValue: "",
      wareHouseValue: "",
      productValue: "",
      productList: [],
      productId: "",
      batchLike: "",
      warehouseList: [],
      warehouseId: "",
      isLossList: [
        {
          key: "",
          value: "全部",
        },
        {
          key: 1,
          value: "损耗单",
        },
        {
          key: 2,
          value: "溢余单",
        },
      ],
      isLoss: "",
      num: 20,
      type: "",
      batchNo: "",
      batchList: [],
      purchaseList: [],
      conditionType: "Number",
      memoryValue: "Batch",
      batDateList: [
        {
          value: "Batch",
          label: "批次号",
        },
        {
          value: "date",
          label: "时间",
        },
      ],
      searchList: [],
      filterSearch: "",
      edit: "",
      start: "", //开始时间
      end: "", //结束时间
      pickerOptionsStart: {
        disabledDate: (time) => {
          let endDateVal = this.end;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.start;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          }
        },
      },
      pickerTimeOptions: {
        // 限制日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      keyword: "", //查找
      totalQuantity: 0,
      totalWeight: 0,
      totalAmount: 0,
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.search, // 当前页数需要调用的函数
        pageSize: 10, // 当前页数
      },
    };
  },

  //默认时间
  created() {
    let startTime = storage.get("start");
    let endTime = storage.get("end");
    if (startTime) {
      this.start = this.$timeformatDay(startTime);
    } else {
      const start = new Date();
      start.setDate(1);
      this.start = this.$timeformatDay(start);
    }
    if (endTime) {
      this.end = endTime;
    } else {
      this.end = this.$timeformatDay(new Date());
    }
  },
  async mounted() {
    this.judgeChoose();
    // 记录查找关键字
    // this.judgeSession("purchaseKeyword");
    this.keyword = this.word;
    this.ajaxBatchList(); // 批次列表
    let warehouse = await this.getWarehouseList({
      pageIndex: 1,
      pageSize: 1000000,
      keyword: "",
    });
    this.warehouseList = warehouse.list;
    this.warehouseList = [
      {
        id: "",
        name: "全部",
      },
    ].concat(this.warehouseList);
    let product = await this.getProductList({
      pageIndex: 1,
      pageSize: 1000000,
      queryName: "",
    });
    this.productList = product.list;
    this.productList = [
      {
        id: "",
        name: "全部",
      },
    ].concat(this.productList);
    this.search(); //初始化数据
  },
  methods: {
    ...mapActions(modules.warehouse, ["getWarehouseList"]),
    ...mapActions(modules.product, ["getProductList"]),
    ...mapActions(modules.batch, ["getBatchList"]),
    ...mapActions(modules.warehouseT, ["exportGainLoss"]),
    batchListFilter(key, list) {
      // 我这里直接return（也可赋给变量return变量出去）
      if (key == "") {
        return list;
      } else {
        return list.filter((item) => {
          // 如果list(name)包含key(输入框) => true
          if (item.batchNo.includes(key)) {
            // 返回item
            return item;
          }
        });
      }
    },
    listFilter(key, list) {
      // 我这里直接return（也可赋给变量return变量出去）
      if (key == "") {
        return list;
      } else {
        return list.filter((item) => {
          // 如果list(name)包含key(输入框) => true
          if (item.name.includes(key)) {
            // 返回item
            return item;
          }
        });
      }
    },
    isLossChange() {
      this.search();
    },
    // 切换仓库
    changeWare(e) {
      this.warehouseId = e;
      this.wareHouseValue = "";
      this.search();
    },
    changeProduct(e) {
      this.productId = e;
      this.productValue = "";
      this.search();
    },
    //合计（后端全量查询结果合计）
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property === "detailQuantity") {
          sums[index] = Number(this.totalQuantity || 0).toFixed(2) + " ";
        } else if (column.property === "detailWeight") {
          sums[index] = Number(this.totalWeight || 0).toFixed(2) + " ";
        } else if (column.property === "amount") {
          sums[index] = Number(this.totalAmount || 0).toFixed(2) + " ";
        } else {
          sums[index] = "--";
        }
      });
      return sums;
    },
    // 判断localstorage 是批次还是日期
    judgeChoose() {
      let memoryValue = localStorage.getItem("memoryValue");
      if (memoryValue == null || memoryValue == undefined) {
        this.memoryValue = "Batch";
      } else if (memoryValue !== "receiptDate") {
        this.memoryValue = memoryValue;
        if (this.memoryValue == "date") {
          this.batch = "";
        }
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 !== 1) {
        return "success-row";
      } else {
        return "fail-row";
      }
    },

    // 获取批次
    ajaxBatchList() {
      let obj = {
        pageIndex: 1,
        pageSize: 10000,
        keyword: "",
      };
      this.getBatchList(obj).then((data) => {
        let batchList = data.list;
        data.list.forEach(function (item) {
          item.id = item.batchNo;
        });
        // console.log(this.batchList);
        // this.batchList = this.batchList.push({
        //   batchNo: "全部",
        //   id: ""
        // });
        this.batchList = [
          {
            id: "",
            batchNo: "全部",
          },
        ].concat(batchList);
      });
    },
    // 切换批次
    batchChange() {
      this.batchValue = "";
      this.search();
    },
    // 格式化指定列时间
    formatter(row) {
      if (!row.dataDate) {
        return false;
      }
      return this.$timeformatDay(row.dataDate);
    },

    changeBatDateList(e) {
      localStorage.setItem("memoryValue", e);
      console.log(e);
      if (e == "Batch") {
        // this.start = "";
        // this.end = "";
      } else if (e == "date") {
        this.batchNo = "";
      }
    },
    //存储选中时间
    changeTime(type) {
      if (type == 0) {
        localStorage.setItem("start", this.start);
      } else {
        localStorage.setItem("end", this.end);
      }
    },

    // 数据导出
    exportData() {
      this.search();
      let obj = {
        // transactionType: 2,
        Batch: this.batchNo == "全部" ? "" : this.batchNo,
        BatchLike: this.batchLike,
        IsLoss: this.isLoss == 1 ? false : this.isLoss == 2 ? true : "",
        StartTime: this.memoryValue == "date" ? this.start : "",
        StopTime: this.memoryValue == "date" ? this.end : "",
        WarehouseId: this.warehouseId,
        Product: this.productId,
        PageIndex: 1,
        PageSize: 10000,
      };

      // if (this.conditionType == "TransactionType") {
      //   obj.TransactionType = this.transactionType;
      // } else {
      //   // 搜索条件
      //   obj[this.conditionType] = this.keyword;
      // }
      // if (obj.TransactionType != null) {
      //   obj.TransactionType = Number(this.transactionType);
      // } else {
      //   obj.TransactionType = null;
      // }
      if (obj.StartTime.indexOf('"') > -1 || obj.StartTime.indexOf("'") > -1) {
        obj.StartTime = obj.StartTime.replace(/"/g, "").replace(/'/g, "");
      }
      if (obj.StartTime.indexOf('"') > -1 || obj.StartTime.indexOf("'") > -1) {
        obj.StartTime = obj.StartTime.replace(/"/g, "").replace(/'/g, "");
      }

      this.exportGainLoss(obj).then((data) => {
        /* 兼容ie内核，360浏览器的兼容模式 */
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          let blob = new Blob([data.data]);
          // window.navigator.msSaveOrOpenBlob(blob, "称重单明细.xls");
          console.log(blob);
          window.navigator.msSaveOrOpenBlob(blob, `损溢明细表.xls`);
        } else {
          /* 火狐谷歌的文件下载方式 */
          var blob = new Blob([data.data]);
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob);
          downloadElement.href = href;
          // downloadElement.download = "称重单明细.xls";
          downloadElement.download = `损溢明细表.xls`;

          document.body.appendChild(downloadElement);
          downloadElement.click();
          document.body.removeChild(downloadElement);
          window.URL.revokeObjectURL(href);
        }
      });
    },

    search(pageNum) {
      this.loading = true;
      this.visible = false;
      // 分页组件传入页码；按钮点击会带上 event，需忽略
      const currentPage = typeof pageNum === "number" ? pageNum : 1;
      let obj = {
        pageIndex: (this.pageInfo.pageNumber = currentPage),
        pageSize: this.pageInfo.pageSize,
        batch: this.batchNo == "全部" ? "" : this.batchNo,
        startTime: this.memoryValue == "date" ? this.start : "",
        stopTime: this.memoryValue == "date" ? this.end : "",
        isLoss: this.isLoss,
        warehouseId: this.warehouseId,
        product: this.productId,
        batchLike: this.batchLike,
      };
      if (this.isLoss == 1) {
        obj.isLoss = false;
      }
      if (this.isLoss == 2) {
        obj.isLoss = true;
      }
      if (obj.startTime.indexOf('"') > -1 || obj.startTime.indexOf("'") > -1) {
        obj.startTime = obj.startTime.replace(/"/g, "").replace(/'/g, "");
      }
      if (obj.stopTime.indexOf('"') > -1 || obj.stopTime.indexOf("'") > -1) {
        obj.stopTime = obj.stopTime.replace(/"/g, "").replace(/'/g, "");
      }

      this.$api
        .getGainLossDetail(obj)
        .then((data) => {
          this.loading = false;
          this.purchaseList = data.data.list;
          if (this.purchaseList.length != 0) {
            this.noData = false;
          } else {
            this.noData = true;
          }
          this.pageInfo.totalPages = data.data.total;
          this.totalQuantity = data.data.totalQuantity || 0;
          this.totalWeight = data.data.totalWeight || 0;
          this.totalAmount = data.data.totalAmount || 0;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="stylus">
//更多条件
.pop-condition{
  .more{
    margin-left:20px;
    padding:0 20px;
    line-height:32px;
    background:linear-gradient(180deg,rgba(255,255,255,1),rgba(230,230,230,1));
    border:1px solid rgba(198, 198, 198, 1);
    border-radius:4px;
    color:#333333;
    cursor:pointer;
  }
}
.el-popover{
  width:580px !important;
  .mask{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding:5px 20px 15px 20px;
    z-index: 20;
    font-size:16px;
    color:#666;
    background:#fff;
    .more{
      margin-left:20px;
    }
    .select-container-box{
      width :260px;
      margin-top:15px;
    }
    .el-input{
      width :180px;
    }
    .el-input__inner{
      height:36px;
      width :180px;
    }
    >div{
      &:nth-child(2n) {
        padding-left:0;
        >span{width:80px;text-align:right;}
      }
    }
  }

  .comfirm{
    text-align:center;
    font-size:16px;

    >span{
      display:inline-block;
      width:100px;
      margin:15px 0;
      border:1px solid #BBBBBB;
      border-radius:4px;
      line-height:36px;
      background :#fff;
      cursor:pointer;
      &:nth-child(2){
        margin-left:20px;
        border:1px solid #3389FF;
        color:#fff;
        background:#3389FF;
      }
    }
  }
}
//更多条件
.el-table .hovered-row {
    background: red !important;
}
.salesDetail
  .tab
    .el-input--small
      width:100px !important;
      min-width:100px !important;
  .content-edit{
    text-decoration: underline;
  }
  //去除type=number 输入款上下箭头
  input[type=number] {
    -moz-appearance:textfield;
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }
  .content-container .select-container-box .el-select__tags {
    max-width: 264px !important;
    width:264px!important;
  }
  .el-table__body-wrapper{
    max-height:calc(100vh - 330px)
    overflow-y:auto;
  }
  .table-container
    .el-table::before
      width:100%!important
      border-bottom:0.5px solid #DDDDDD!important
    .el-table .el-table__body tbody td
      border-bottom 1px solid #DDD!important;
    .el-table .el-table__row:nth-of-type(even)
      background #fff !important;
  .el-table__footer-wrapper
    tr td {
      background:#FFF8F2;
      .cell{
        padding:12px 0;
        line-height:normal !important;
      }
    }
</style>
